export const DOWNLOAD_APPLE_CHIP_MAC_URL = 'https://download.brain.fm/darwin/arm64/Brain.fm-0.0.199-arm64.dmg';
export const DOWNLOAD_INTEL_CHIP_MAC_URL = 'https://download.brain.fm/darwin/x64/Brain.fm-0.0.199-x64.dmg';
export const DOWNLOAD_WINDOWS_URL = 'https://download.brain.fm/win32/x64/Brain.fm-0.0.199%20Setup.exe';
